import type { ErrorInfo } from "react"

import { datadogRum } from "@datadog/browser-rum"

export const logError = (error: unknown, info: ErrorInfo) => {
  datadogRum.addError(error, info)
}
